const _ = require('lodash')
import storage from 'good-storage'
import store from '@/store'
import { guid } from '@/utils/common.js'
import { EventBus } from '@/utils/event-bus.js'
import { sendErrorLog } from '@/utils/common.js'

const version = process.env.chain_port == '9080' ? '-2.0' : ''

const Keys = {
    LAST_LOGIN_TIME: 'vircle_lastlogintime' + version,
    USER_LOGIN_DATA: 'vircle_userlogincache' + version,
    USER_CHECKED_STATUS: uid => 'vircle_usercheckedstatus_' + uid,
    LAST_ADDRESS: keyId => 'vircle_lastAddress-' + keyId + version,
    ACCOUNTS_STATU: uid => 'vircle_accounts_statu_' + uid + version,
    ACCOUNTS_TX_RECORDS: keyId => 'vircle_tx_records_' + keyId + version,
    ACCOUNTS_REWARDS: keyId => 'vircle_rewards_' + keyId + version,
    ACCOUNTS_TEMP_RECORDS: keyId => 'vircle_tx_records_temp_' + keyId + version,
    USER_CONTACT_LIST: uid => 'vircle_contact_list_' + uid + version,
    USER_ACCOUNT: uid => 'vircle_accounts_' + uid + version,
    USER_NODE_DATA: cid => 'vircle_node_data_' + cid + version,
    COLLECTION_ACCOUNT_LIST: uid => 'vircle_collection_accounts_' + uid + version
}

// 监听通过APP存取数据
window['setStorageResult'] = (...arg) => loadStorageResult(...arg)

// 监听
function loadStorageResult(k, v) {
    EventBus.$emit('cache_' + k, v)
}

function loadValueFromApp(k) {
    return new Promise((resolve, reject) => {
        try {
            window.readAppStorage(k)
            EventBus.$on('cache_' + k, (value) => {
                EventBus.$off('cache_' + k)
                if (value && value != '') return resolve(JSON.parse(value))
                return resolve(null)
            })
        } catch (error) {
            console.log(error)
            sendErrorLog('[appcache.js-loadValueFromApp]' + error)
            return reject(error)
        }
    })
}

// //////////自测

export function getCheckStatus() {
  return new Promise((resolve, reject) => {
      if (store.state.app.isinapp && process.env.use_app_cache) {
          const uid = store.state.user.id
          if (!uid) {
              return reject('用户未设置')
          }
          loadValueFromApp(Keys.USER_CHECKED_STATUS(uid)).then(value => {
              return resolve(value)
          }).catch((e) => {
              sendErrorLog('[appcache.js-getCheckStatus]' + e)
              return reject('读取缓存失败')
          })
      } else {
          return resolve(_getCheckStatus())
      }
  })
}

function _getCheckStatus() {
  const uid = store.state.user.id
  if (!uid) {
      return false
  }

  try {
      const value = storage.get(Keys.USER_CHECKED_STATUS(uid))
      if (value) {
          return value
      } else {
          return false
      }
  } catch (e) {
  // TODO handle the exception
      sendErrorLog('[appcache.js-_getCheckStatus]' + e)
      return false
  }
}

export function saveCheckStatus(val) {
  if (store.state.app.isinapp && process.env.use_app_cache) {
      const uid = store.state.user.id
      if (!uid) {
          return false
      }
      try {
          window.writeAppStorage(Keys.USER_CHECKED_STATUS(uid), val)
          return true
      } catch (e) {
          // TODO handle the exception
          sendErrorLog('[appcache.js-saveCheckStatus]' + e)
          return false
      }
  } else {
      return _saveCheckStatus(val)
  }
}

function _saveCheckStatus(val) {
  const cid = store.state.user.id
  if (!cid) {
      return false
  }
  try {
      storage.set(Keys.USER_CHECKED_STATUS(cid), val)
      return true
  } catch (e) {
  // TODO handle the exception
      sendErrorLog('[appcache.js-_saveCheckStatus]' + e)
      return false
  }
}

// //////////////////////////主节点信息
/**
 * 获取节点信息
 * @param {Object} cid 钱包id
 */
export function getOneNode(ip) {
    return new Promise((resolve, reject) => {
        if (store.state.app.isinapp && process.env.use_app_cache) {
            getNodeList().then(arr => {
                if (!arr) return resolve(false)
                const node = _.filter(arr, i => {
                    return i.ip == ip
                })
                if (node) return resolve(node[0])
                return resolve(false)
            }).catch(e => {
                sendErrorLog('[appcache.js-getOneNode]' + e)
                return reject(e)
            })
        } else {
            return resolve(_getOneNode(ip))
        }
    })
}

function _getOneNode(ip) {
    const arr = _getNodeList()
    if (!arr) return false
    const node = _.filter(arr, i => {
        return i.ip == ip
    })
    if (node) return node[0]
    return false
}



/**
 * 获取节点信息
 * @param {Object} cid 钱包id
 */
export function getNodeList() {
    return new Promise((resolve, reject) => {
        if (store.state.app.isinapp && process.env.use_app_cache) {
            const cid = store.state.user.id
            if (!cid) {
                return reject('钱包账户未找到')
            }
            loadValueFromApp(Keys.USER_NODE_DATA(cid)).then(value => {
                return resolve(value)
            }).catch((e) => {
                sendErrorLog('[appcache.js-getNodeList]' + e)
                return reject('读取缓存失败')
            })
        } else {
            return resolve(_getNodeList())
        }
    })
}

function _getNodeList() {
    const cid = store.state.user.id
    if (!cid) {
        return false
    }

    try {
        const value = storage.get(Keys.USER_NODE_DATA(cid))
        if (value) {
            return value
        } else {
            return false
        }
    } catch (e) {
    // TODO handle the exception
        sendErrorLog('[appcache.js-_getNodeList]' + e)
        return false
    }
}

/**
 * 删除一个节点
 * @param {Object} cid 钱包id
 */
export function delOneNode(ip) {
    return new Promise((resolve, reject) => {
        if (store.state.app.isinapp && process.env.use_app_cache) {
            getNodeList().then(arr => {
                if (!arr) {
                    return resolve(true)
                }
                _.remove(arr, val => {
                    return val.ip == ip
                })
                saveNodeList(arr)
                return resolve(true)
            }).catch(e => {
                sendErrorLog('[appcache.js-delOneNode]' + e)
                return reject(e)
            })
        } else {
            return resolve(_delOneNode(ip))
        }
    })
}

function _delOneNode(ip) {
    const arr = _getNodeList()
    if (!arr) {
        return true
    }
    _.remove(arr, val => {
        return val.ip == ip
    })
    _saveNodeList(arr)
    return true
}

/**
 * 获取节点信息
 * @param {Object} cid 钱包id
 */
export function saveOneNode(item) {
    return new Promise((resolve, reject) => {
        if (store.state.app.isinapp && process.env.use_app_cache) {
            getNodeList().then(arr => {
                if (!arr) {
                    arr = []
                    arr.push(item)
                    saveNodeList(arr)
                    return resolve(true)
                }
                if (!(arr instanceof Array)) {
                    arr = []
                }
                let ishave = false
                for (let index = 0; index < arr.length; index++) {
                    if (arr[index].ip == item.ip) {
                        ishave = true
                        arr[index] = item
                        break
                    }
                }

                if (!ishave) {
                    arr.push(item)
                    saveNodeList(arr)
                    return resolve(true)
                } else {
                    saveNodeList(arr)
                    return resolve(true)
                }
            }).catch(e => {
                sendErrorLog('[appcache.js-saveOneNode]' + e)
                return reject(e)
            })
        } else {
            return resolve(_saveOneNode(item))
        }
    })
}

function _saveOneNode(item) {
    let arr = _getNodeList()
    if (!arr) {
        arr = []
        arr.push(item)
        _saveNodeList(arr)
        return true
    }
    let ishave = false
    for (let index = 0; index < arr.length; index++) {
        if (arr[index].ip == item.ip) {
            ishave = true
            arr[index] = item
            break
        }
    }

    if (!ishave) {
        arr.push(item)
        _saveNodeList(arr)
        return true
    } else {
        _saveNodeList(arr)
        return true
    }
}

/**
 * 保存节点信息
 * @param {Object} val
 */
export function saveNodeList(val) {
    if (store.state.app.isinapp && process.env.use_app_cache) {
        const cid = store.state.user.id
        if (!cid) {
            return false
        }
        try {
            window.writeAppStorage(Keys.USER_NODE_DATA(cid), JSON.stringify(val))
            return true
        } catch (e) {
            // TODO handle the exception
            sendErrorLog('[appcache.js-saveNodeList]' + e)
            return false
        }
    } else {
        return _saveNodeList(val)
    }
}

function _saveNodeList(val) {
    const cid = store.state.user.id
    if (!cid) {
        return false
    }
    try {
        storage.set(Keys.USER_NODE_DATA(cid), val)
        return true
    } catch (e) {
    // TODO handle the exception
        sendErrorLog('[appcache.js-_saveNodeList]' + e)
        return false
    }
}

// /////////////////////////////////////////////////////

/**
 * 获取所有联系人
 */
export function loadAllContacts() {
    return new Promise((resolve, reject) => {
        if (store.state.app.isinapp && process.env.use_app_cache) {
            const uid = store.state.user.id
            if (!uid) {
                return reject('用户信息未找到')
            }
            try {
                loadValueFromApp(Keys.USER_CONTACT_LIST(uid)).then(value => {
                    if (value) {
                        return resolve(value)
                    } else {
                        return resolve(null)
                    }
                })
            } catch (e) {
            // TODO handle the exception
                sendErrorLog('[appcache.js-loadAllContacts]' + e)
                return reject('读取缓存失败')
            }
        } else {
            return resolve(_loadAllContacts())
        }
    })
}
function _loadAllContacts() {
    const uid = store.state.user.id
    if (!uid) {
        return null
    }
    try {
        const value = storage.get(Keys.USER_CONTACT_LIST(uid))
        if (value) {
            return value
        } else {
            return null
        }
    } catch (e) {
    // TODO handle the exception
        sendErrorLog('[appcache.js-_loadAllContacts]' + e)
        return null
    }
}

/**
 * 获取指定ID的联系人
 */
export function loadOneContact(cid) {
    return new Promise((resolve, reject) => {
        if (store.state.app.isinapp && process.env.use_app_cache) {
            loadAllContacts().then(arr => {
                if (!arr) return resolve(null)
                const item = _.find(arr, i => {
                    return i.id == cid
                })
                return resolve(item || null)
            }).catch(e => {
                sendErrorLog('[appcache.js-loadOneContact]' + e)
                return reject(e)
            })
        } else {
            return resolve(_loadOneContact(cid))
        }
    })
}

function _loadOneContact(cid) {
    const arr = _loadAllContacts()
    if (!arr) return null
    const item = _.find(arr, i => {
        return i.id == cid
    })
    return item || null
}

/**
 * 缓存所有联系人
 * @param {Object} val
 */
export function setAllContacts(val) {
    if (store.state.app.isinapp && process.env.use_app_cache) {
        const uid = store.state.user.id
        if (!uid) {
            return false
        }
        // if (!val || val.length == 0) {
        //   return false
        // }
        try {
            window.writeAppStorage(Keys.USER_CONTACT_LIST(uid), JSON.stringify(val))
            return true
        } catch (e) {
            // TODO handle the exception
            sendErrorLog('[appcache.js-setAllContacts]' + e)
            return false
        }
    } else {
        return _setAllContacts(val)
    }
}

function _setAllContacts(val) {
    const uid = store.state.user.id
    if (!uid) {
        return false
    }
    // if (!val || val.length == 0) {
    //   return false
    // }
    try {
        storage.set(Keys.USER_CONTACT_LIST(uid), val)
        return true
    } catch (e) {
    // TODO handle the exception
        sendErrorLog('[appcache.js-_setAllContacts]' + e)
        return false
    }
}

/**
 * 缓存一个联系人
 * @param {Object} val
 */
export function setOneContact(val) {
    return new Promise((resolve, reject) => {
        if (store.state.app.isinapp && process.env.use_app_cache) {
            loadAllContacts().then(arr => {
                arr = arr && arr.length > 0 ? arr : []
                val.id = guid()
                if (val.id) {
                    arr.push(val)
                } else {
                    return resolve(false)
                }
                return resolve(setAllContacts(arr))
            }).catch(e => {
                sendErrorLog('[appcache.js-setOneContact]' + e)
                return reject(e)
            })
        } else {
            return resolve(_setOneContact(val))
        }
    })
}
function _setOneContact(val) {
    let arr = _loadAllContacts()
    arr = arr && arr.length > 0 ? arr : []
    val.id = guid()
    if (val.id) {
        arr.push(val)
    } else {
        return false
    }
    return _setAllContacts(arr)
}

/**
 * 更新一个联系人
 * @param {Object} val
 */
export function updateContact(val) {
    return new Promise((resolve, reject) => {
        if (store.state.app.isinapp && process.env.use_app_cache) {
            if (!val.id) {
                return resolve(false)
            }
            loadAllContacts().then(arr => {
                if (!arr) return resolve(false)
                let isHave = false
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].id == val.id) {
                        arr[i] = val
                        isHave = true
                        break
                    }
                }
                if (!isHave) {
                    return resolve(false)
                }
                return resolve(setAllContacts(arr))
            }).catch(e => {
                sendErrorLog('[appcache.js-updateContact]' + e)
                return reject(e)
            })
        } else {
            return resolve(_updateContact(val))
        }
    })
}

function _updateContact(val) {
    if (!val.id) {
        return false
    }
    const arr = _loadAllContacts()
    if (!arr) return false
    let isHave = false
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].id == val.id) {
            arr[i] = val
            isHave = true
            break
        }
    }
    if (!isHave) {
        return false
    }
    return _setAllContacts(arr)
}

/**
 * 删除一个联系人
 * @param {Object} cid
 */
export function deleteContact(cid) {
    return new Promise((r, j) => {
        if (store.state.app.isinapp && process.env.use_app_cache) {
            if (!cid) {
                return r(false)
            }
            loadAllContacts().then(arr => {
                if (!arr) return r(false)
                let isHave = false
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].id == cid) {
                        arr.splice(i, 1)
                        isHave = true
                        break
                    }
                }
                if (!isHave) {
                    return r(false)
                }
                return r(setAllContacts(arr))
            }).catch(e => {
                sendErrorLog('[appcache.js-deleteContact]' + e)
                return j(e)
            })
        } else {
            return r(_deleteContact(cid))
        }
    })
}

function _deleteContact(cid) {
    if (!cid) {
        return false
    }
    const arr = _loadAllContacts()
    if (!arr) return false
    let isHave = false
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].id == cid) {
            arr.splice(i, 1)
            isHave = true
            break
        }
    }
    if (!isHave) {
        return false
    }
    return _setAllContacts(arr)
}

// //////////////////////////////////////////////////////////

/**
 * 获取钱包
 * @param {Object} keyId
 */
export function getAccount() {
    return new Promise((resolve, reject) => {
        if (store.state.app.isinapp && process.env.use_app_cache) {
            const uid = store.state.user.id
            if (!uid) {
                return reject('获取用户信息失败')
            }
            loadValueFromApp(Keys.USER_ACCOUNT(uid)).then(value => {
                return resolve(value)
            }).catch((e) => {
                sendErrorLog('[appcache.js-getAccount]' + e)
                return reject('读取缓存失败')
            })
        } else {
            return resolve(_getAccount())
        }
    })
}
function _getAccount() {
    const uid = store.state.user.id
    if (!uid) {
        return false
    }

    try {
        const value = storage.get(Keys.USER_ACCOUNT(uid))
        if (value) {
            return value
        } else {
            return false
        }
    } catch (e) {
    // TODO handle the exception
        sendErrorLog('[appcache.js-_getAccount]' + e)
        return false
    }
}

/**
 * 保存钱包
 * @param {Object} val
 */
export function saveAccount(val) {
    if (store.state.app.isinapp && process.env.use_app_cache) {
        const uid = store.state.user.id
        if (!uid) {
            return false
        }
        try {
            window.writeAppStorage(Keys.USER_ACCOUNT(uid), JSON.stringify(val))
            // storage.set(Keys.USER_ACCOUNT(uid), val)
            return true
        } catch (e) {
            // TODO handle the exception
        // alert(e)
            console.log(e)
            sendErrorLog('[appcache.js-saveAccount]' + e)
            return false
        }
    } else {
        return _saveAccount(val)
    }
}
function _saveAccount(val) {
    const uid = store.state.user.id
    console.log('用户ID:', uid)
    if (!uid) {
        return false
    }
    try {
        storage.set(Keys.USER_ACCOUNT(uid), val)
        return true
    } catch (e) {
    // TODO handle the exception
        sendErrorLog('[appcache.js-_saveAccount]' + e)
        return false
    }
}

// //////////////////////////////////////////////////////////

/**
 * 获取钱包地址
 * @param {Object} keyId
 */
export function getLastAddress(keyId) {
    return new Promise((r, j) => {
        if (store.state.app.isinapp && process.env.use_app_cache) {
            loadValueFromApp(Keys.LAST_ADDRESS(keyId)).then(value => {
                if (value && value != '') return r(value.val)
                return r(value)
            }).catch((e) => {
              sendErrorLog('[appcache.js-getLastAddress]' + e)
                return j('读取缓存失败')
            })
        } else {
            return r(_getLastAddress(keyId))
        }
    })
}
function _getLastAddress(keyId) {
    try {
        const value = storage.get(Keys.LAST_ADDRESS(keyId))
        if (value) {
            return value
        } else {
            return null
        }
    } catch (e) {
    // TODO handle the exception
        sendErrorLog('[appcache.js-_getLastAddress]' + e)
        return null
    }
}

/**
 * 缓存钱包地址
 * @param {Object} keyId
 * @param {Object} address
 */
export function setLastAddress(keyId, address) {
    if (store.state.app.isinapp && process.env.use_app_cache) {
        try {
            window.writeAppStorage(Keys.LAST_ADDRESS(keyId), JSON.stringify({ val: address }))
            return true
        } catch (e) {
        // TODO handle the exception
        sendErrorLog('[appcache.js-setLastAddress]' + e)
            return false
        }
    } else {
        return _setLastAddress(keyId, address)
    }
}
function _setLastAddress(keyId, address) {
    try {
        storage.set(Keys.LAST_ADDRESS(keyId), address)
        return true
    } catch (e) {
    // TODO handle the exception
    sendErrorLog('[appcache.js-_setLastAddress]' + e)
        return false
    }
}

// /////////////////////

/**
 * 获取所有收款账户
 */
export function loadAllCollectionAccounts() {
    return new Promise((r, j) => {
        if (store.state.app.isinapp && process.env.use_app_cache) {
            const uid = store.state.user.id
            if (!uid) {
                return r(null)
            }
            loadValueFromApp(Keys.COLLECTION_ACCOUNT_LIST(uid)).then(value => {
                return r(value)
            }).catch((e) => {
              sendErrorLog('[appcache.js-loadAllCollectionAccounts]' + e)
                return j('读取缓存失败')
            })
        } else {
            return r(_loadAllCollectionAccounts())
        }
    })
}

function _loadAllCollectionAccounts() {
    const uid = store.state.user.id
    if (!uid) {
        return null
    }
    try {
        const value = storage.get(Keys.COLLECTION_ACCOUNT_LIST(uid))
        console.log('获取到记录：', value)
        if (value) {
            return value
        } else {
            return null
        }
    } catch (e) {
        console.log(e)
        sendErrorLog('[appcache.js-_loadAllCollectionAccounts]' + e)
        return null
    }
}

/**
 * 缓存一个收款账户
 * @param {Object} val
 */
export function setOneCollectionAccount(val) {
    return new Promise((r, j) => {
        if (store.state.app.isinapp && process.env.use_app_cache) {
            loadAllCollectionAccounts().then(arr => {
                arr = arr && arr.length > 0 ? arr : []
                val.id = guid()
                if (val.id) {
                    arr.push(val)
                } else {
                    return r(false)
                }
                return r(setAllCollectionAccounts(arr))
            }).catch(e => {
              sendErrorLog('[appcache.js-setOneCollectionAccount]' + e)
                return j(e)
            })
        } else {
            return r(_setOneCollectionAccount(val))
        }
    })
}
function _setOneCollectionAccount(val) {
    let arr = _loadAllCollectionAccounts()
    arr = arr && arr.length > 0 ? arr : []
    val.id = guid()
    if (val.id) {
        arr.push(val)
    } else {
        return false
    }
    return _setAllCollectionAccounts(arr)
}

/**
 * 缓存所有收款账户
 * @param {Object} val
 */
export function setAllCollectionAccounts(val) {
    if (store.state.app.isinapp && process.env.use_app_cache) {
        const uid = store.state.user.id
        if (!uid) {
            return false
        }
        if (!val || val.length == 0) {
            val = []
        }
        try {
            window.writeAppStorage(Keys.COLLECTION_ACCOUNT_LIST(uid), JSON.stringify(val))
            return true
        } catch (e) {
            // TODO handle the exception
            console.log(e)
            sendErrorLog('[appcache.js-setAllCollectionAccounts]' + e)
            return false
        }
    } else {
        return _setAllCollectionAccounts(val)
    }
}
function _setAllCollectionAccounts(val) {
    const uid = store.state.user.id
    if (!uid) {
        return false
    }
    if (!val || val.length == 0) {
        val = []
    }
    try {
        storage.set(Keys.COLLECTION_ACCOUNT_LIST(uid), val)
        return true
    } catch (e) {
    // TODO handle the exception
    sendErrorLog('[appcache.js-_setAllCollectionAccounts]' + e)
        return false
    }
}

/**
 * 删除一个收款账户
 * @param {Object} cid
 */
export function deleteCollectionAccount(cid) {
    return new Promise((r, j) => {
        loadAllCollectionAccounts().then(arr => {
            console.log('记录：', arr)
            if (!arr) return r(false)
            let isHave = false
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].id == cid) {
                    console.log('查找到匹配记录')
                    arr.splice(i, 1)
                    isHave = true
                    break
                }
            }
            console.log('新arr', arr)
            if (!isHave) {
                return r(false)
            }
            return r(setAllCollectionAccounts(arr))
        }).catch(e => {
          sendErrorLog('[appcache.js-deleteCollectionAccount]' + e)
            return j(e)
        })
    })
}

// function _deleteCollectionAccount(cid) {
//     if (!cid) {
//         return false
//     }
//     const arr = _loadAllCollectionAccounts()
//     console.log('获取到账户列表：', arr)
//     if (!arr) return false
//     let isHave = false
//     for (let i = 0; i < arr.length; i++) {
//         if (arr[i].id == cid) {
//             arr.splice(i, 1)
//             isHave = true
//             break
//         }
//     }
//     if (!isHave) {
//         return false
//     }
//     return _setAllCollectionAccounts(arr)
// }

/**
 *获取指定ID的收款账户
 */
export function loadOneCollectionAccount(cid) {
    return new Promise((r, j) => {
        if (store.state.app.isinapp && process.env.use_app_cache) {
            loadAllCollectionAccounts().then(arr => {
                if (!arr) return r(null)
                const item = _.find(arr, i => {
                    return i.id == cid
                })
                return r(item || null)
            }).catch(e => {
              sendErrorLog('[appcache.js-loadOneCollectionAccount]' + e)
                return j(e)
            })
        } else {
            return r(_loadOneCollectionAccount(cid))
        }
    })
}
function _loadOneCollectionAccount(cid) {
    const arr = _loadAllCollectionAccounts()
    if (!arr) return null
    const item = _.find(arr, i => {
        return i.id == cid
    })
    return item || null
}

/**
 *获取默认收款账户
 */
export function getDefaultConnlectionAccount() {
    return new Promise((r, j) => {
        if (store.state.app.isinapp && process.env.use_app_cache) {
            loadAllCollectionAccounts().then(arr => {
                if (!arr) return r(null)
                const item = _.find(arr, i => {
                    return i.isActive == true
                })
                return r(item || null)
            }).catch(e => {
              sendErrorLog('[appcache.js-getDefaultConnlectionAccount]' + e)
                return j(e)
            })
        } else {
            return r(_getDefaultConnlectionAccount())
        }
    })
}
function _getDefaultConnlectionAccount() {
    const arr = _loadAllCollectionAccounts()
    if (!arr) return null
    const item = _.find(arr, i => {
        return i.isActive == true
    })
    return item || null
}

/**
 * 设置默认的收款方式
 */
export function setOneDefaultConnlectionAccount(cid) {
    return new Promise((r, j) => {
        if (store.state.app.isinapp && process.env.use_app_cache) {
            loadAllCollectionAccounts().then(arr => {
                if (!arr) return r(null)
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].id === cid) {
                        arr[i].isActive = true
                    } else {
                        arr[i].isActive = false
                    }
                }
                return r(setAllCollectionAccounts(arr))
            }).catch(e => {
              sendErrorLog('[appcache.js-setOneDefaultConnlectionAccount]' + e)
                return j(e)
            })
        } else {
            return r(_setOneDefaultConnlectionAccount(cid))
        }
    })
}

function _setOneDefaultConnlectionAccount(cid) {
    const arr = _loadAllCollectionAccounts()
    if (!arr) return null
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].id === cid) {
            arr[i].isActive = true
        } else {
            arr[i].isActive = false
        }
    }
    return _setAllCollectionAccounts(arr)
}



// WEBPACK FOOTER //
// ./src/utils/appcache.js